import { Moments, State, ValidGeneralInformation, MomentState } from './type'
function reducer(state: State, moment: Moments): State {
    switch (moment.type) {
        case MomentState.VALID_MAIN_CONTENT_GENERAL_INFORMATION:
            state.isValidGeneralInformation = moment.isValid
    }
    return state
}
const DEFAULT_STATE = {
    isValidGeneralInformation: false
} as State

export { reducer, DEFAULT_STATE }
